import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { useGetTranslations } from '@/composables/useGetTranslations';
export default defineComponent({
  name: 'MerchandisingLabels',
  props: {
    merchLabels: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var merchData = computed(function () {
      var data = Object.keys(props.merchLabels).filter(function (key) {
        return props.merchLabels[key] !== false;
      });
      return data.map(function (key) {
        if (props.merchLabels[key] === undefined) return {};
        var isBestseller = key === 'best-seller';
        return {
          key: isBestseller ? 'bestSeller' : props.merchLabels[key],
          className: isBestseller ? 'best-seller' : 'usage-type',
          translatable: isBestseller
        };
      });
    });
    return {
      translate: translate,
      merchData: merchData
    };
  }
});